(function () {
  var formatMoney = function (cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var amount = cents / 100;
    return '$' + amount.toFixed(2);
  };

  var getSkioPicker = function () {
    return document.querySelector('skio-plan-picker');
  };

  var getSkioVariantPrice = function () {
    var picker = getSkioPicker();
    var variant = picker && picker.selectedVariant;
    return variant ? Number(variant.price) : NaN;
  };

  // Copy the already-rounded price text from the product-section Skio picker.
  var getSkioPriceTexts = function (isSubscription) {
    var picker = getSkioPicker();
    if (!picker || !picker.querySelector) return null;

    var el = picker.querySelector(
      isSubscription
        ? '.subscription-group-container .skio-price'
        : '.group-container:not(.subscription-group-container) .skio-price'
    );
    if (!el) return null;

    var strike = el.querySelector('s');
    var compare = strike ? strike.textContent.trim() : '';
    var clone = el.cloneNode(true);
    var strikeClone = clone.querySelector('s');
    if (strikeClone) strikeClone.parentNode.removeChild(strikeClone);
    var active = (clone.textContent || '').replace(/\s+/g, ' ').trim();
    if (!active) return null;
    return { active: active, compare: compare };
  };

  var firstTruthy = function () {
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i]) return arguments[i];
    }
    return undefined;
  };

  var normalizePlanId = function (value) {
    if (value === null || typeof value === 'undefined') return '';
    var asString = String(value);
    var gidMatch = asString.match(/(\d+)(?!.*\d)/);
    return gidMatch ? gidMatch[1] : asString;
  };

  var getCurrentSellingPlan = function (root) {
    var sectionRoot =
      (root && root.closest && root.closest('[data-section-type="product"]')) ||
      document;

    // Explicit OTP/subscription group toggle takes precedence when present.
    var purchaseGroup = sectionRoot.querySelector('input[name="selling-plan-group"]:checked');
    if (purchaseGroup && purchaseGroup.value === '') return '';

    var variantInput = document.querySelector('input[name="id"][form^="ProductForm--"]');
    var formId = variantInput ? variantInput.getAttribute('form') : null;
    var scopedSelector = formId ? '[name="selling_plan"][form="' + formId + '"]' : '[name="selling_plan"]';

    var checked = sectionRoot.querySelector('input' + scopedSelector + ':checked');
    if (checked) return checked.value;

    var selected = sectionRoot.querySelector('select' + scopedSelector);
    if (selected) return selected.value;

    var hidden = sectionRoot.querySelector('input' + scopedSelector);
    return hidden ? hidden.value : '';
  };

  var getCurrentVariantId = function () {
    var idInput = document.querySelector('input[name="id"][form^="ProductForm--"]');
    if (!idInput) return null;
    return parseInt(idInput.value, 10);
  };

  var renderPrices = function (root, activePrice, compareAt) {
    var activeEls = root.querySelectorAll('[data-active-price]');
    var compareEls = root.querySelectorAll('[data-compare-price]');
    var activeText = typeof activePrice === 'string' ? activePrice : formatMoney(activePrice);
    var compareText = typeof compareAt === 'string' ? compareAt : formatMoney(compareAt);
    var showCompare =
      (typeof compareAt === 'string' && compareAt) ||
      (typeof compareAt === 'number' && compareAt > 0 && compareAt > activePrice);

    activeEls.forEach(function (el) {
      if (activeText) el.textContent = activeText;
    });

    compareEls.forEach(function (el) {
      if (showCompare && compareText) {
        el.textContent = compareText;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  };

  var updateState = function (root, productData, forcedSellingPlanId) {
    var variantId = getCurrentVariantId();
    var sellingPlanId =
      typeof forcedSellingPlanId !== 'undefined'
        ? String(forcedSellingPlanId || '')
        : getCurrentSellingPlan(root);
    var isSubscription = Boolean(sellingPlanId);
    var normalizedSellingPlanId = normalizePlanId(sellingPlanId);

    var variants = productData && productData.variants ? productData.variants : [];
    var variant =
      variants.find(function (item) { return item.id === variantId; }) ||
      variants[0];

    var compareAt = variant ? variant.compare_at_price : null;
    var activePrice = variant ? variant.price : null;
    var allocation = null;
    var skioTexts = getSkioPriceTexts(isSubscription);

    if (skioTexts) {
      renderPrices(root, skioTexts.active, isSubscription ? skioTexts.compare : '');
    } else {
      if (variant && variant.selling_plan_allocations && variant.selling_plan_allocations.length) {
        if (isSubscription) {
          allocation = variant.selling_plan_allocations.find(function (item) {
            return normalizePlanId(item.selling_plan_id) === normalizedSellingPlanId;
          });

          // Keep previous behavior only when no plan id is known (defensive fallback).
          if (!allocation && !normalizedSellingPlanId) {
            allocation = variant.selling_plan_allocations[0];
          }

          if (allocation) {
            var skioPrice = getSkioVariantPrice();
            var basePrice = !isNaN(skioPrice) ? skioPrice : Number(variant.price);
            activePrice = allocation.price;
            compareAt = firstTruthy(basePrice, allocation.compare_at_price, compareAt);
          }
        }
      }

      if (!isSubscription) {
        // OTP should show full one-time price as primary (no strike-through compare)
        activePrice = firstTruthy(variant && variant.compare_at_price, activePrice);
        compareAt = null;
      }

      renderPrices(root, activePrice, compareAt);
    }

    var offerEl = root.querySelector('[data-offer-pill]');
    var perDayEl = root.querySelector('[data-per-day]');
    var ctaEl = root.querySelector('[data-sticky-cta-text]');
    var shippingEl = root.querySelector('[data-trust="shipping"]');
    var guaranteeEl = root.querySelector('[data-trust="guarantee"]');

    if (isSubscription) {
      if (offerEl) offerEl.style.display = '';
      if (perDayEl) perDayEl.style.display = '';
      if (shippingEl) shippingEl.style.display = '';
      if (guaranteeEl) guaranteeEl.style.display = '';
      if (ctaEl) ctaEl.textContent = root.dataset.subCta;
    } else {
      if (offerEl) offerEl.style.display = 'none';
      if (perDayEl) perDayEl.style.display = 'none';
      if (shippingEl) shippingEl.style.display = 'none';
      if (guaranteeEl) guaranteeEl.style.display = 'none';
      if (ctaEl) ctaEl.textContent = root.dataset.otpCta;
    }
  };

  var attachAtcAction = function (root) {
    var stickyButton = root.querySelector('[data-sticky-add-to-cart]');
    if (!stickyButton) return;

    stickyButton.addEventListener('click', function () {
      var mainAtc = document.querySelector('[data-add-to-cart]');
      if (!mainAtc) return;

      stickyButton.classList.add('is-loading');
      stickyButton.disabled = true;
      mainAtc.click();
    });

    var removeLoading = function () {
      stickyButton.classList.remove('is-loading');
      stickyButton.disabled = false;
    };

    document.addEventListener('theme:product:added', removeLoading);
    document.addEventListener('theme:cart:error', removeLoading);
    // Fallback: remove loading after 5s in case events don't fire
    document.addEventListener('theme:product:added', function () {
      setTimeout(removeLoading, 100);
    });
  };

  var toggleVisibility = function (root) {
    var mainAtc = document.querySelector('[data-add-to-cart]');
    if (!mainAtc) {
      root.classList.remove('is-visible');
      return;
    }

    var rect = mainAtc.getBoundingClientRect();
    var viewHeight = window.innerHeight || document.documentElement.clientHeight;
    var isMainAtcVisible = rect.bottom >= 0 && rect.top <= viewHeight;
    var isDesktop = window.innerWidth >= 990;
    var isFirstScreenDesktop = isDesktop && window.scrollY < window.innerHeight;
    var mainAtcBottomOnPage = rect.bottom + window.scrollY;
    var hasScrolledPastMainAtc = window.scrollY > mainAtcBottomOnPage;

    if (!isDesktop) {
      // Mobile: show only after user scrolls past main ATC CTA.
      root.classList.toggle('is-visible', hasScrolledPastMainAtc);
      return;
    }

    // Desktop: keep previous behavior.
    root.classList.toggle('is-visible', !isMainAtcVisible && !isFirstScreenDesktop);
  };

  var boot = function () {
    if (!document.body.classList.contains('irsbb-variant')) return;

    var root = document.querySelector('.info-rich-sticky-buy-bar');
    if (!root) return;
    if (root.dataset.eligibleProduct !== 'true') return;

    var productJsonEl = root.querySelector('[data-sticky-product-json]');
    if (!productJsonEl || !productJsonEl.textContent) return;

    var productData = null;
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      return;
    }

    attachAtcAction(root);

    // Initial render must reflect current OTP/subscription selection on PDP
    updateState(root, productData);

    toggleVisibility(root);

    // Dynamic updates when user interacts with variant/selling plan selectors
    document.addEventListener('change', function () { updateState(root, productData); });
    document.addEventListener('skio::update-selling-plan', function (event) {
      var detail = event && event.detail ? event.detail : {};
      var forcedId;

      // Skio sends `sellingPlan` only when subscription is selected.
      // If the field is missing/null, treat it as explicit OTP.
      if (Object.prototype.hasOwnProperty.call(detail, 'sellingPlan')) {
        forcedId = detail.sellingPlan && detail.sellingPlan.id ? detail.sellingPlan.id : '';
      } else if (Object.prototype.hasOwnProperty.call(detail, 'value')) {
        forcedId = detail.value || '';
      } else {
        // Fallback for payloads without sellingPlan/value:
        // if variant doesn't require plan, assume OTP.
        forcedId = detail.variant && detail.variant.requires_selling_plan === false ? '' : undefined;
      }

      updateState(root, productData, forcedId);
    });
    document.addEventListener('change', function (event) {
      var target = event && event.target;
      if (!target || !target.matches || !target.matches('input[name="selling-plan-group"]')) return;
      setTimeout(function () { updateState(root, productData); }, 0);
    });
    document.addEventListener('theme:variant:change', function () { updateState(root, productData); });
    document.addEventListener('theme:product:added', function () { updateState(root, productData); });
    document.addEventListener('scroll', function () { toggleVisibility(root); }, { passive: true });
    window.addEventListener('resize', function () { toggleVisibility(root); });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
